export default __webpack_public_path__ + "static/media/landing.30ee0322.png";